import { ChangeDetectorRef, Component, ElementRef, Inject, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import * as txml from 'txml';
import { ActivatedRoute, Router } from '@angular/router';
import { MobileViewService } from '../../../utils/shared-services/mobileView/mobileView.service';
import { ConceptApiService } from '../services/concept.resource';
import { ConfirmDisableHOPortalDialog } from './dialogs/confirm-disable-portal-dialog.component';
import { ValidationService } from '../../../utils/shared-services/validation.service';
import { EnableHOPortal } from '../models/enable-ho-portal.model';
import { SelectPrimaryStoreDialog } from './dialogs/select-primary-store-dialog.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EoiApiService } from '../../eoi/services/eoi.resource';
import { BasicEoiInfo, EoiInformation, EOIQuickStatus, EOIQuickStatusResponse } from '../../eoi/models/eoi.model';
import { eoiService as EoiService } from '../../eoi/services/eoi.service';
import { BrowserStorage } from '../../../utils/shared-services/browser-storage.service';
import { EoiStatusDialog } from '../../eoi/components/dialogs/eoi-status-dialog.component';
import { HOPortalApiService } from '../../head-office-portal/services/head-office-portal.resource';
import { HOPortalService } from '../../head-office-portal/services/head-office-portal.service';
import { HeadOfficePortalData } from '../../head-office-portal/models/head-office-portal.model';
import { WidgetInfo } from '../../store-portal/models/widget.model';
import { View, ViewForm } from '../../store-portal/models/view.model';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { take } from 'rxjs';
import { HoWidgetDescriptionDialog } from '../../head-office-portal/components/dialogs/widget-description-dialog.component';
import { ConfirmDeleteViewDialog } from '../../stores/components/dialogs/confirm-delete-view-dialog.component';
import { SnackbarService } from '../../../utils/shared-services/snackbar/snackbar.service';


@Component({
    selector: 'app-store-portal',
    templateUrl: 'src/app/features/concepts/templates/enable-ho-portal.html',
    standalone: false
})
export class EnableHOPortalComponent {

    private baseURl: URL;
    private fb: FormBuilder = new FormBuilder();

    public portalIDForm = this.fb.group({
        pathName: ['', [Validators.required, Validators.maxLength(this.validationService.portalIDMaxLength), Validators.minLength(this.validationService.portalIDMinLength)]],
        storeName: ['']
    });

    public captions: Record<string, string>;
    private eoiInfo: BasicEoiInfo;
    public eoiStatus: string = 'color-grey';
    public portalURL: string = '';
    public pathName: string = '';
    public enabled: boolean = false;
    public configActive: boolean = false;
    public isEditingPortalID: boolean = false;

    public searchStr: string = '';
    public hoPortalDemoLink: string;
    public conceptID: number;
    public primaryStoreID: number;
    public availableWidgets: { id: string }[] = [];
    private allWidgets: { id: string }[] = [];
    public widgetsInfo: Record<string, WidgetInfo> = {};
    public selectedTabIdx: number = 1;
    public selectedViewConfigIdx = 0;

    public viewsForm = this.fb.group({
        views: this.fb.array<FormGroup<ViewForm>>([]),
    });

    public widValueForm = this.fb.group({
        message: ['', []],
        hourlySalesBreakdown1column1Selection: ['0', Validators.required],
        hourlySalesBreakdown1column2Selection: ['16', Validators.required],
        hourlySalesBreakdown1column3Selection: ['4', Validators.required],
        hourlySalesBreakdown1column4Selection: ['3', Validators.required],
        hourlySalesBreakdown2column1Selection: ['0', Validators.required],
        hourlySalesBreakdown2column2Selection: ['16', Validators.required],
        hourlySalesBreakdown2column3Selection: ['0', Validators.required],
        hourlySalesBreakdown2column4Selection: ['3', Validators.required],
    });

    @ViewChildren('viewInput') viewInputs: QueryList<ElementRef>;
    config: any[];

    constructor(
        @Inject(ActivatedRoute) private actRoute: ActivatedRoute,
        @Inject(Router) private router: Router,
        @Inject(EoiService) private eoiService: EoiService,
        @Inject(BrowserStorage) private browserStorage: BrowserStorage,
        @Inject(EoiApiService) private eoiApiService: EoiApiService,
        @Inject(ConceptApiService) private conceptApiService: ConceptApiService,
        @Inject(MobileViewService) private mobileViewService: MobileViewService,
        @Inject(MatDialog) private dialog: MatDialog,
        @Inject(DeviceDetectorService) private deviceService: DeviceDetectorService,
        @Inject(ValidationService) public validationService: ValidationService,
        @Inject(MatSnackBar) private snackBar: MatSnackBar,
        @Inject(HOPortalApiService) private hoPortalApiService: HOPortalApiService,
        @Inject(HOPortalService) private hoPortalService: HOPortalService,
        @Inject(SnackbarService) private snackbarService: SnackbarService,
        @Inject(ChangeDetectorRef) private cd: ChangeDetectorRef
    ) {
        this.actRoute.data.subscribe((data) => {
            this.captions = data.captions;
        });

        this.mobileViewService.setBreakpoint(MobileViewService.MOBILE_BREAKPOINT_MEDIUM);
        this.conceptID = +this.actRoute.snapshot.paramMap.get('pathId');
        this.baseURl = new URL(window.location.toString().replace(this.router.url, '/hoPortal'));
        this.hoPortalDemoLink = 'https://www.youtube.com/embed/FNcv2eS-pGE?ecver=1';
    }

    ngOnInit(): void {
        this.portalIDForm.get('pathName').disable();
        this.portalIDForm.get('storeName').disable();
        this.portalIDForm.get('pathName').markAsTouched();

        this.loadEnableConceptPortal();
    }

    private loadEnableConceptPortal(): void {
        this.allWidgets = this.hoPortalService.getAllWidgets();
        this.widgetsInfo = this.hoPortalService.getWidgetsInfo();
        this.conceptApiService.getEnableConceptPortal(this.conceptID).then((response: EnableHOPortal) => {
            if (response) {
                this.pathName = response.pathName;
                this.updatePortalURL(response.pathName);
                this.enabled = response.isActive === 1;
                this.primaryStoreID = response.primaryStore;
                this.portalIDForm.get('storeName').setValue(response.storeName);
                this.portalIDForm.get('pathName').setValue(this.pathName);

                this.views.clear();
                this.config = this.hoPortalService.parseSavedConfig(
                    response?.config ? JSON.parse(response.config) : null
                );
                this.config.forEach(view => this.addView(view, false));
                
                if (response?.widgetValueConfig)
                {
                    let parsedWidValues = JSON.parse(response.widgetValueConfig);

                    this.widValueForm.patchValue({
                        message: parsedWidValues.message ? parsedWidValues.message : '',

                        // hourly sales breakdown column index
                        hourlySalesBreakdown1column1Selection: parsedWidValues.hourlySalesBreakdown1column1Selection
                            ? parsedWidValues.hourlySalesBreakdown1column1Selection
                            : '0',
                        hourlySalesBreakdown1column2Selection: parsedWidValues.hourlySalesBreakdown1column2Selection
                            ? parsedWidValues.hourlySalesBreakdown1column2Selection
                            : '16',
                        hourlySalesBreakdown1column3Selection: parsedWidValues.hourlySalesBreakdown1column3Selection
                            ? parsedWidValues.hourlySalesBreakdown1column3Selection
                            : '4',
                        hourlySalesBreakdown1column4Selection: parsedWidValues.hourlySalesBreakdown1column4Selection
                            ? parsedWidValues.hourlySalesBreakdown1column4Selection
                            : '3',
                        hourlySalesBreakdown2column1Selection: parsedWidValues.hourlySalesBreakdown2column1Selection
                            ? parsedWidValues.hourlySalesBreakdown2column1Selection
                            : '0',
                        hourlySalesBreakdown2column2Selection: parsedWidValues.hourlySalesBreakdown2column2Selection
                            ? parsedWidValues.hourlySalesBreakdown2column2Selection
                            : '16',
                        hourlySalesBreakdown2column3Selection: parsedWidValues.hourlySalesBreakdown2column3Selection
                            ? parsedWidValues.hourlySalesBreakdown2column3Selection
                            : '4',
                        hourlySalesBreakdown2column4Selection: parsedWidValues.hourlySalesBreakdown2column4Selection
                            ? parsedWidValues.hourlySalesBreakdown2column4Selection
                            : '3',
                    });
                }
            }
            if (this.enabled) {
                // Update EOI status
                this.eoiApiService.getEoiByID(this.primaryStoreID, this.getTimeRange(), 8, 1, null).then((eoi: EoiInformation) => {
                    this.eoiApiService.getQuickStatus(this.primaryStoreID, 15000000).then((eoiStatusResponse: EOIQuickStatusResponse) => {
                        const { Response } = txml.simplify(txml.parse(eoiStatusResponse.responseString));
                        if (Response?.ErrorNum === '-1') {
                            return;
                        }

                        const eoiQuickStatus = Response.Status as EOIQuickStatus;
                        this.eoiStatus = this.eoiService.getQuickStatusColor(eoiQuickStatus);
                        if (this.eoiStatus === 'color-yellow') {
                            this.eoiStatus = 'color-green';
                        }
                        this.eoiInfo = {
                            okToOrder: eoiQuickStatus.OkToOrder,
                            posOnline: eoiQuickStatus.PosOnline,
                            eoiOnline: eoiQuickStatus.EoiOnline,
                            disconnectedTime: eoi?.disconnectedTime,
                        };
                    });
                });
            }
            this.setAvailableWidgets();
        });
    }

    private updatePortalURL(aPathName: string): void {
        this.baseURl.searchParams.set('PortalID', aPathName);
        this.portalURL = this.baseURl.toString();
    }

    private getTimeRange(): number {
        let timeRange = this.browserStorage.getSessionstorage('timeRange', undefined);
        return timeRange == null ? 7 : timeRange;
    }

    toggleConfig(): void {
        this.configActive = !this.configActive;
    }

    itemDropped(event: CdkDragDrop<string[]>): void {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(
                event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex
            );
        }
    }

    get views() {
        return this.viewsForm.controls['views'];
    }

    deleteView(idx: number): void {
        if (this.views.controls.length <= 1) {
            this.snackbarService.errorMessageTop('Portal must have at least one view');
            return;
        }

        let viewInfo: Partial<View> = this.views.controls[idx].value;
        if (viewInfo.title.length === 0 && viewInfo.widgets.length === 0) {
            this.removeView(idx);
            return;
        }

        this.dialog
            .open(ConfirmDeleteViewDialog, {
                panelClass: 'app-full-bleed-dialog',
                maxWidth: '90vw',
                data: {
                    view: viewInfo,
                },
            })
            .afterClosed()
            .subscribe((res: boolean) => {
                if (res) {
                    this.removeView(idx);
                }
            });
    }

    addView(view: Partial<View>, focusLastElement: boolean = true): void {
        let nextNum: number;
        if (focusLastElement) {
            this.viewInputs.changes.pipe(take(1)).subscribe({
                next: (changes) => {
                    changes.last.nativeElement.focus();
                    this.cd.detectChanges();
                },
            });
            // get value for next view based on last element in views array
            const lastElement = this.views.value[this.views.length - 1];
            nextNum = lastElement.id + 1;

        }
        let viewForm: FormGroup<ViewForm> = this.fb.group({
            id: [view.id ?? nextNum],
            title: [view.title ?? '', [Validators.required, Validators.maxLength(this.validationService.portalConfigTitleMaxLength), Validators.minLength(this.validationService.portalConfigTitleMinLength)]],
            widgets: [view.widgets ?? []],
        });
        this.views.push(viewForm);
    }

    private removeView(idx: number): void {
        this.views.removeAt(idx);
        if (this.selectedViewConfigIdx >= this.views.controls.length) {
            this.selectedViewConfigIdx = this.views.controls.length - 1;
        }
    }

    // Populate the available widgets column on the left side of the screen
    // filter widgets that are selected for view
    setAvailableWidgets(): void {
        this.availableWidgets = this.allWidgets.filter(wid1 => {
            return (
                this.views.controls[this.selectedViewConfigIdx].value.widgets.findIndex((wid2) => wid1.id === wid2.id) <
                0 && this.widgetsInfo[wid1.id].title.toLowerCase().includes(this.searchStr.toLowerCase())
            );
        });
    }

    saveConfig(): void {
        this.config = [];
        this.views.controls.forEach((control) => this.config.push(control.value));
        let hoPortal: EnableHOPortal = {
            primaryStore: this.primaryStoreID,
            storeName: this.pathName,
            conceptID: this.conceptID,
            pathName: this.pathName,
            isActive: this.enabled ? 1 : 0,
            config: JSON.stringify(this.config),
            widgetValueConfig: JSON.stringify(this.widValueForm.value),
            isOnline: 0
        };
        this.conceptApiService.enableOrUpdateConceptPortal(hoPortal).then(() => {
            this.toggleConfig()
        });
    }

    openInfoDialog(widgetID: string): void {
        this.hoPortalApiService.getWidgetDescriptionHTMLByID(widgetID).then((desc) => {
            this.dialog.open(HoWidgetDescriptionDialog, {
                panelClass: 'app-full-bleed-dialog',
                maxWidth: '95vw',
                data: {
                    widgetID: widgetID,
                    descriptionHTML: desc,
                },
            });
        });
    }

    enablePortal(): void {
        const dialogRef = this.dialog.open(SelectPrimaryStoreDialog, {
            panelClass: 'app-full-bleed-dialog',
            maxWidth: '950vw',
            minWidth: '50vw',
            data: {
                conceptID: this.conceptID,
            },
        });

        dialogRef.afterClosed().subscribe((res: EnableHOPortal) => {
            if (res.primaryStore) {
                let hoPortal: EnableHOPortal = {
                    conceptID: this.conceptID,
                    primaryStore: res.primaryStore,
                    storeName: res.storeName,
                    pathName: this.pathName,
                    isActive: 1,
                    config: '',
                    widgetValueConfig: '',
                    isOnline: 0
                };
                this.conceptApiService.enableConceptPortal(hoPortal.conceptID, hoPortal.primaryStore).then((res: any) => {
                    this.pathName = res.pathName;
                    this.portalIDForm.get('pathName').setValue(this.pathName);
                    this.portalIDForm.get('storeName').setValue(hoPortal.storeName);
                    this.enabled = true;
                });
            }
        });
    }


    disablePortal(): void {
        const dialogRef = this.dialog.open(ConfirmDisableHOPortalDialog, {
            panelClass: 'app-full-bleed-dialog',
            maxWidth: '95vw',
        });

        dialogRef.afterClosed().subscribe((res: boolean) => {
            if (res) {
                this.conceptApiService.disableConceptPortal(this.conceptID).then(() => {
                    this.enabled = false;
                });
            }
        });
    }

    toggleEditPortalID(): void {
        this.isEditingPortalID = !this.isEditingPortalID;
        this.portalIDForm.get('pathName').setValue(this.pathName);
        this.isEditingPortalID
            ? this.portalIDForm.get('pathName').enable()
            : this.portalIDForm.get('pathName').disable();
    }

    // login to store portal api and forward to portal home page
    openHQPortal(): void {
        // checking if the app is running on a Desktop browser.
        const isDesktopDevice = this.deviceService.isDesktop();
        if (!isDesktopDevice) {
            this.snackBar.open(this.captions.enableNewTab, this.captions.ok, {
                duration: 10000,
                verticalPosition: 'top',
                horizontalPosition: 'center',
            });
        }
        this.hoPortalApiService
            .hqLoginForHOPortal(
                this.pathName,
                '',
                'HQUser',
                this.browserStorage.getSessionstorage('userAccess', null)
            )
            .then((res: HeadOfficePortalData) => {
                res.ConceptID = this.conceptID;
                this.hoPortalService.setHoPortalData(res);
                if (res?.AccessToken) {
                    window.open('hoPortal/home/0', '_blank');
                }
            });
    }

    openPortal(): void {
        // checking if the app is running on a Desktop browser.
        this.browserStorage.setSessionstorage('portalConceptID', this.conceptID)
        const isDesktopDevice = this.deviceService.isDesktop();
        if (!isDesktopDevice) {
            this.snackBar.open(this.captions.enableNewTab, this.captions.ok, {
                duration: 10000,
                verticalPosition: 'top',
                horizontalPosition: 'center',
            });
        }
        window.open(this.portalURL, '_blank');
    }

    eoiStatuses(): void {
        const dialogRef = this.dialog.open(EoiStatusDialog, {
            panelClass: 'app-full-bleed-dialog',
            maxWidth: '95vw',
            data: {
                eoiOnline: this.eoiInfo?.eoiOnline,
                posOnline: this.eoiInfo?.posOnline,
                okToOrder: this.eoiInfo?.okToOrder,
                disconnectedtime: this.eoiInfo?.disconnectedTime,
                isStorePortal: true,
                isCountSheet: false,
            },
        });

        dialogRef.backdropClick().subscribe(() => {
            dialogRef.close();
        });
    }
}
